import { render, staticRenderFns } from "./product-search.vue?vue&type=template&id=ee2f3e8c&"
import script from "./product-search.vue?vue&type=script&lang=js&"
export * from "./product-search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports